// @ts-nocheck
// Injects Blog nav link only when previewing the draft theme.
(function () {
  if (!new URLSearchParams(window.location.search).has('preview_theme_id')) return;

  const BLOG_URL   = '/blogs/news';
  const BLOG_TITLE = 'Blog';

  // Find a nav <a> by its visible text label
  function findLinkByText(text) {
    return Array.from(document.querySelectorAll('a')).find(a =>
      a.textContent.trim().toLowerCase() === text.toLowerCase()
    );
  }

  function injectIntoList(ul) {
    // Skip if already injected
    if (Array.from(ul.querySelectorAll('a')).some(a =>
      a.textContent.trim().toLowerCase() === BLOG_TITLE.toLowerCase()
    )) return;

    // Find "About Us" li inside this ul
    const items = Array.from(ul.children);
    const aboutLi = items.find(li => {
      const a = li.querySelector('a');
      return a && a.textContent.trim().toLowerCase() === 'about us';
    });

    const anchor = aboutLi || items[items.length - 1];
    if (!anchor) return;

    // Clone that item — inherits all Vessel classes and structure perfectly
    const newLi = anchor.cloneNode(true);

    // Point every <a> to the blog
    newLi.querySelectorAll('a').forEach(a => {
      a.setAttribute('href', BLOG_URL);
      a.classList.remove('menu-list__link--active', 'is-active', 'active');
      // Remove any aria-current
      a.removeAttribute('aria-current');
    });

    // Set visible label — update the deepest span, or the <a> itself
    const spans = newLi.querySelectorAll('span');
    const labelEl = spans.length ? spans[spans.length - 1] : newLi.querySelector('a');
    if (labelEl) labelEl.textContent = BLOG_TITLE;

    // Remove any dropdown / submenu / mega-menu children
    newLi.querySelectorAll(
      '[class*="submenu"], [class*="dropdown"], [class*="mega"], [class*="overflow"]'
    ).forEach(el => el.remove());

    if (aboutLi && aboutLi.nextSibling) {
      ul.insertBefore(newLi, aboutLi.nextSibling);
    } else {
      ul.appendChild(newLi);
    }
  }

  function inject() {
    // Find any <ul> that contains an "About Us" link by text
    document.querySelectorAll('ul').forEach(ul => {
      const hasAbout = Array.from(ul.querySelectorAll('a')).some(
        a => a.textContent.trim().toLowerCase() === 'about us'
      );
      if (hasAbout) injectIntoList(ul);
    });
  }

  function run() {
    inject();

    // Retry via MutationObserver in case Vessel renders nav asynchronously
    let injected = false;
    const mo = new MutationObserver(() => {
      const aboutLink = findLinkByText('about us');
      if (aboutLink && !injected) {
        inject();
        injected = true;
        mo.disconnect();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
